import { KFCard } from '@kf/ic2fx';
import { Box, Divider, Stack, Skeleton } from '@mui/material';
import React from 'react';
import { colors } from 'styles/colors';
import CandidateFeedbackDetailHeaderShimmer from './candidateFeedbackDetailHeaderShimmer';

const RatingDotsskeleton = () => {
  return (
    <>
      {[...Array(5)].map((d, i) => {
        return (
          <Stack key={i}>
            <Skeleton
              data-testid={`rating-dots-${i}`}
              variant='circular'
              width={14}
              height={14}
              sx={{
                bgcolor: (theme) => theme.palette.neutral?.main,
              }}
            />
          </Stack>
        );
      })}
    </>
  );
};

const IndividualFeedbackShimmer = () => {
  return (
    <>
      {[...Array(1)]?.map((_, i) => {
        return (
          <KFCard
            key={i}
            id={`feedback-section-shimmer-${i}`}
            data-testid={`feedback-section-shimmer-${i}`}
            sx={{ border: `1px solid ${colors.connector.border}` }}
          >
            <CandidateFeedbackDetailHeaderShimmer />
            <Divider
              sx={{
                mt: 1,
                mb: 2,
                borderColor: colors.border.gainsboroDarkGrey,
              }}
            />
            <Box
              sx={{
                mt: 1,
                mb: 2,
                borderColor: colors.border.gainsboroDarkGrey,
                bgcolor: (theme) => theme.palette.neutral?.main,
              }}
            />
            <Stack direction='row' gap={2.5}>
              <Stack gap={1.25} sx={{ flex: 1 }}>
                <Skeleton
                  data-testid='skeleton-1'
                  variant='rectangular'
                  width={207}
                  height={24}
                  sx={{
                    bgcolor: (theme) => theme.palette.neutral?.main,
                  }}
                />

                {[...Array(6)]?.map((d, index) => {
                  return (
                    <Stack
                      key={index}
                      sx={{
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Skeleton
                        data-testid='skill'
                        variant='rectangular'
                        width={112}
                        height={20}
                        sx={{
                          bgcolor: (theme) => theme.palette.neutral?.main,
                        }}
                      />
                      <RatingDotsskeleton />
                    </Stack>
                  );
                })}
              </Stack>
              <Divider
                orientation='vertical'
                sx={{
                  width: '1px',
                  height: '12.938rem',
                  borderColor: colors.border.gainsboroDarkGrey,
                }}
              />
              <Stack
                gap={1.25}
                sx={{
                  flex: 2.125,
                  bgcolor: (theme) => theme.palette.neutral?.main,
                }}
              >
                <Skeleton
                  data-testid='comments'
                  variant='rectangular'
                  width={77}
                  height={24}
                  sx={{
                    bgcolor: (theme) => theme.palette.neutral?.main,
                  }}
                />
                <Skeleton
                  data-testid='comments'
                  variant='rectangular'
                  width={490}
                  height={140}
                  sx={{
                    bgcolor: (theme) => theme.palette.neutral?.main,
                  }}
                />
              </Stack>
            </Stack>
          </KFCard>
        );
      })}
    </>
  );
};

export default IndividualFeedbackShimmer;
